module.exports = __webpack_public_path__ + "img/pd-img-head9.8f04d60f.png";